import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import '../../../static/less/new_shopping_cart/board_details_block2.css';
import { getLangValue } from '../../../utils/Generic';
import { CALL_CENTER_ROLE } from '../../../constants';

const BoardDetailsBlock2 = (props, context) => {
  if (!props.hotel) return null;

  let boardName = null;
  let boardDescription = null;
  let boardNatureExperience = null;

  // === Obtener board seleccionado como en el componente original ===
  if (props.multipleRoomSelection['1']) {
    const roomData = props.multipleRoomSelection['1'];
    if (roomData?.room?.rates?.length) {
      const rate = roomData.room.rates.find((r) => r.code === roomData.rateCode);
      const board = rate?.boards?.find((b) => b.code === roomData.boardCode);
      if (board) {
        boardName = getLangValue(board, props.lang, 'name');
        let description_key = 'description';
        if ('hotel_board_description' in board) {
          description_key = 'hotel_board_description';
        }
        let nature_experience_key = 'nature_experience';
        if ('hotel_board_nature_experience' in board) {
          nature_experience_key = 'hotel_board_nature_experience';
        }
        boardDescription = getLangValue(board, props.lang, description_key);
        boardNatureExperience = getLangValue(board, props.lang, nature_experience_key);
      }
    }
  }

  // Fallback si no se encuentra descripción
  if (!boardName && props.hotel?.rooms && props.hotel.rooms['1']) {
    const board = props.hotel.rooms['1'][0].rates[0].boards[0];
    boardName = getLangValue(board, props.lang, 'name');
    let description_key = 'description';
    if ('hotel_board_description' in board) {
      description_key = 'hotel_board_description';
    }
    boardDescription = getLangValue(board, props.lang, description_key);
    let nature_experience_key = 'nature_experience';
    if ('hotel_board_nature_experience' in board) {
      nature_experience_key = 'hotel_board_nature_experience';
    }
    boardNatureExperience = getLangValue(board, props.lang, nature_experience_key);
  }

  // === Procesar texto de descripción ===
  const itemsDescription = boardDescription
    ? boardDescription.split(/\r?\n/).map((item) => item.trim()).filter(Boolean)
    : [];
  const itemsNatureExperience = boardNatureExperience
    ? boardNatureExperience.split(/\r?\n/).map((item) => item.trim()).filter(Boolean)
    : [];

  return (
    <>
      <section className="board2-container">
        <h2 className="board2-title">{boardName || context.t('Board Type')}:</h2>
        <div className="board2-items">
          {itemsDescription.map((item, index) => {
            const isNote = item.startsWith('*');
            return (
              <div key={index} className={`board2-item${isNote ? ' board2-item--note' : ''}`}>
                {!isNote && <span className="bullet">•</span>}
                <span className="text">{item}</span>
              </div>
            );
          })}
        </div>
      </section>
      {itemsNatureExperience.length > 0 && (
        <section className="board2-container">
          <h2 className="board2-title">{context.t('All nature experience')}:</h2>
          <div className="board2-items">
            {itemsNatureExperience.map((item, index) => {
              const isNote = item.startsWith('*');
              return (
                <div key={index} className={`board2-item${isNote ? ' board2-item--note' : ''}`}>
                  {!isNote && <span className="bullet">•</span>}
                  <span className="text">{item}</span>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};

BoardDetailsBlock2.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
}))(BoardDetailsBlock2);
